import React from 'react'
import CateogaryPost from './CateogaryPost';
import data from '../FakeData/index.json'

function MainCateogary({ blogs, head }) {
    return (
        <div className="w3l-homeblock2 py-5">
            <div className="container py-lg-5 py-md-4">
                <div className="left-right">
                    <h3 className="section-title-left mb-sm-4 mb-2"> {head.charAt(0).toUpperCase() + head.slice(1)} </h3>
                    <a href={`/cateogary/${String(head).toLocaleLowerCase()}`} className="more btn btn-small mb-sm-0 mb-4" style={{ background: `#5a67d8` }}>View more</a>
                </div>
                <div className="row">
                    {blogs.map((blog) => {
                        return <CateogaryPost key={blog.id} slug={blog.slug} image={blog.Image} PostHead={blog.Headline} authorName={data[0].authorName} date={blog.date} time={blog.Time} />
                    })}
                </div>
            </div>
        </div>

    )
}

export default MainCateogary
